import { render, staticRenderFns } from "./Payback.vue?vue&type=template&id=6b92622d&"
import script from "./Payback.vue?vue&type=script&lang=js&"
export * from "./Payback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports